module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-pound-b05d5b9c4d661d84f2ee1652e26f3f84.svg";